import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { Button, FontIcon } from '@gik/ui';
import SavedProductsList from './SavedProductsList';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';

const blockName = 'saved-products-section';

export interface ISavedArticlesSection {}

export default function SavedProductsSection() {
  const bem = bemBlock(blockName);
  const { t } = useTranslation();

  return (
    <section className={bem()}>
      <div className={bem('title')}>{t(translationKeys.title)}</div>
      <SavedProductsList />
      <Button
        className={bem('button')}
        type="a"
        externalLink
        href="/give"
        variant="primary"
        prepend={<FontIcon name="wishlist" />}
      >
        {t(translationKeys.btnSeeAll)}
      </Button>
    </section>
  );
}
